
import Address from '../types/address';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'AddressSelectorItem',
  data() {
    return {
      mTracking: 'estimate_landing_address_list_estimate_step1',
    };
  },
  props: {
    item: {
      type: Object as PropType<Address>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(item: Address): void {
      this.$emit('selectItem', item, this.mTracking);
    },
  },
});
